<template>
	<div>
		<DetailArmada ref="modalDetailArmada"></DetailArmada>
		<ModalArmada ref="modalArmada" @action="saveData"></ModalArmada>
		<modalconfirm ref="modalconfirmArmada" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Armada</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn dark depressed class="primary lighten-1" @click="showModalArmada">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Armada</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary lighten-1 mr-2">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn class="primary lighten-1" text dark @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
						<v-icon v-if="!dropfilter">mdi-menu-down</v-icon>
						<v-icon v-if="dropfilter">mdi-menu-up</v-icon>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="pa-2 mb-2" v-if="dropfilter">
				<v-card
					outlined
					class="pa-2 mb-2"
				>
					<v-col cols="12" class="py-0">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field v-model="plat.value" outlined dense hide-details label="Nomor Kendaraan" color="primary lighten-1"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-autocomplete v-model="tipe.value" :items="typeList" outlined dense hide-details label="Tipe Kendaraan" color="primary lighten-1"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3" >
								<v-text-field v-model="brand.value" outlined dense hide-details label="Brand Kendaraan" color="primary lighten-1"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-text-field v-model="model.value" outlined dense hide-details label="Model Kendaraan" color="primary lighten-1"></v-text-field>
							</v-col>
							<!-- <v-col cols="12" md="3" >
								<v-autocomplete v-model="active.value" :items="activeList" outlined dense hide-details label="Aktif" color="primary lighten-1"></v-autocomplete>
							</v-col> -->
						</v-row>
					</v-col>
				</v-card>

				<v-col cols="12" class="pa-0">
					<v-row>
						<v-col cols="12" md="12" class="my-auto text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()"><v-icon class="mr-1" dense>mdi-autorenew</v-icon>Reset</v-btn>
							<v-btn depressed color="primary lighten-1" dark class="ml-2 text-capitalize" @click="cari()"><v-icon class="mr-1" dense>mdi-magnify</v-icon>Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>

			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table :headers="headers" :loading="loading" loading-text="Sedang memuat data..." :items="listArmada" hide-default-footer no-data-text="Tidak ada data tersedia">
				<template v-slot:item.vehicle_type="{ item }">
					<div>{{ item.vehicle_type | armadaType }}</div>
				</template>
				<template v-slot:item.vehicle_color="{ item }">
					<div class="text-capitalize">{{ item.vehicle_color }}</div>
				</template>
				<template v-slot:item.vehicle_condition="{ item }">
					<div>{{ item.vehicle_condition | armadaCondition }}</div>
				</template>
				<template v-slot:item.vehicle_is_active="{ item }">
					<v-switch color="primary lighten-1" true-value="active" false-value="inactive" v-model="item.vehicle_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.vehicle_id)">
								<v-icon dark>mdi-text-box-search</v-icon>
							</v-btn>
						</template>
						<span>Detail</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="edit(item)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="showConfirmation(item.vehicle_id, item.vehicle_model, item.vehicle_registration_number)">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row>
				<v-col cols="12" md="11" class="py-0 d-flex justify-start">
					<v-pagination v-model="page" :length="armadaPagination.total_page" total-visible="5" circle class="d-flex justify-end no-button-focus" color="primary lighten-1" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="primary lighten-1" @input="changeLimit"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ModalArmada from './ModalArmada';
import DetailArmada from './DetailArmada';

export default {
	components: {
		ModalArmada, DetailArmada
	},
	data () {
		return {
			dropfilter: false,
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			propDelete: '',
			activeList:[
			{value: "active", text: "Aktif"},
			{value: "inactive", text: "Tidak Aktif"},
			],
			typeList: [
			{value: "pick_up", text: "Pick Up"},
			{value: "grand_max", text: "Grand Max"},
			{value: "box_cde", text: "Box CDE (Engkel)"},
			{value: "box_cdd", text: "Box CDD (Double)"},
			{value: "fuso", text: "Fuso"},
			{value: "tronton", text: "Tronton"},
			{value: "wingbox", text: "Wingbox"},
			{value: "trailer", text: "Trailer"},
			{value: "container", text: "Container"},
			{value: "other", text: "Lainnya"}
			],
			headers: [
			{ text: 'Nomor Kendaraan', align: 'start', sortable: false, value: 'vehicle_registration_number',},
			{ text: 'Tipe', sortable: false, value: 'vehicle_type' },
			{ text: 'Brand', sortable: false, value: 'vehicle_brand' },
			{ text: 'Model', sortable: false, value: 'vehicle_model' },
			{ text: 'Warna', sortable: false, value: 'vehicle_color' },
			{ text: 'Kondisi', sortable: false, value: 'vehicle_condition' },
			{ text: 'Aktif', sortable: false, value: 'vehicle_is_active' },
			{ text: 'Aksi', sortable: false, value: 'action' },
			],
			plat: {
				value:'',
				comparison:'like',
				type:'string',
				field:'vehicle_registration_number'
			},
			brand: {
				value:'',
				comparison:'like',
				type:'string',
				field:'vehicle_brand'
			},
			model: {
				value:'',
				comparison:'like',
				type:'string',
				field:'vehicle_model'
			},
			tipe: {
				value:'',
				comparison:'like',
				type:'string',
				field:'vehicle_type'
			},
			active: {
				value:'',
				comparison:'=',
				type:'string',
				field:'vehicle_is_active'
			},
		}
	},
	computed: {
		...mapState('armada', ['listArmada', 'armadaPagination']),
	},
	methods: {
		...mapActions('armada', ['getArmada', 'getDetailArmada', 'addArmada', 'editArmada', 'deleteArmada', 'statusArmada']),
		...mapMutations('armada', ['saveResponse']),

		cari() {
			this.params = []
			if(this.plat.value)
				this.params.push(this.plat)

			if(this.brand.value)
				this.params.push(this.brand)

			if(this.model.value)
				this.params.push(this.model)

			if(this.tipe.value)
				this.params.push(this.tipe)

			if(this.active.value)
				this.params.push(this.active)

			this.getArmada(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		resetFilter() {
			this.plat.value = ''
			this.brand.value = ''
			this.model.value = ''
			this.tipe.value = ''
			this.active.value = ''
			this.params = []
			this.limit = 10
			this.getArmada(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		getDetail(id) {
			this.getDetailArmada(id).then(()=> {
				this.$refs.modalDetailArmada.modalShow()
			})
		},
		changePage(page) {
			this.page = page
			this.getArmada(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getArmada(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		showModalArmada() {
			this.$refs.modalArmada.modalShow()
		},
		edit(data) {
			this.$refs.modalArmada.modalShow(data)
		},
		saveData(data, action) {
			if (action == 'add') {
				this.addArmada(data).then(() => {
					this.$refs.modalArmada.modalHide()
					this.getArmada(this.queryString({limit:this.limit, page: this.page, params:this.params}))
				})
			} else if (action == 'edit') {
				this.editArmada(data).then(() => {
					this.$refs.modalArmada.modalHide()
					this.getArmada(this.queryString({limit:this.limit, page: this.page, params:this.params}))
				})
			}
		},
		showConfirmation(id, name, plat){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name} ${plat}`
			this.$refs.modalconfirmArmada.setMessage(msg)
			this.$refs.modalconfirmArmada.showConfirm()
		},
		deleteData() {
			this.deleteArmada(this.propDelete).then( () => {
				this.getArmada(this.queryString({limit:this.limit, page: this.page, params:this.params}))
				this.$refs.modalconfirmArmada.hideConfirm()
			})
		},
		editStatus(data) {
			this.statusArmada({
				id: data.vehicle_id,
				status: data.vehicle_is_active
			}).then(() => {
				this.getArmada(this.queryString({limit:this.limit, page: this.page, params:this.params}))
			})
		},
		async getListArmada() {
			this.loading = await true
			this.getArmada().then(() => {
				setTimeout(() => {
					this.loading = false
				}, 1000)
			})
			.catch(() => {
				setTimeout(() => {
					this.loading = false
				}, 1000)
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Data Armada`)
		this.getListArmada()
	}
};

</script>
